export default "__VITE_ASSET__4MWQAAJO__"